import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'

const Modal = ({ open, onClose, title, children, footer }) => {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog as='div' className='relative z-50' onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-200'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-150'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-black/30 backdrop-blur-sm' />
        </Transition.Child>
        <div className='fixed inset-0 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center p-4'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-200'
              enterFrom='opacity-0 translate-y-1'
              enterTo='opacity-100 translate-y-0'
              leave='ease-in duration-150'
              leaveFrom='opacity-100 translate-y-0'
              leaveTo='opacity-0 translate-y-1'
            >
              <Dialog.Panel className='w-full max-w-lg rounded-2xl bg-white shadow-soft border border-slate-200'>
                <div className='px-6 py-4 border-b border-slate-100'>
                  <Dialog.Title className='text-xl font-semibold tracking-tight text-ink'>{title}</Dialog.Title>
                </div>
                <div className='px-6 py-4'>{children}</div>
                {footer && (
                  <div className='px-6 py-4 flex justify-end gap-3 border-t border-slate-100'>
                    {footer}
                  </div>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default Modal
